import "@fontsource/archivo-black/400.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/700.css";
import "@fontsource/bebas-neue/400.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/staatliches/400.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
